import { Col, Form, Input, Row, Divider, Breadcrumb, Select } from 'antd';
import { MainLayout } from 'components';
import { Content } from 'antd/lib/layout/layout';
import { Link, useHistory, useParams } from 'react-router-dom';
import Button from 'components/Button';
import { AddFillIcon, Remove, XFillIcon } from 'assets/svg';
import { useEffect, useLayoutEffect, useState } from 'react';
import { IBrand } from 'interface/brand.interface';
// import { approveList } from 'mock/approve-mockup';
import pageTitleStore from 'store/pageTitleStore';
import { IUser } from 'interface/user.interface';
import { useMutation } from 'react-query';
import RoleBasedAuth from 'apis/RoleBasedAPI';
import { useForm } from 'antd/es/form/Form';
import { translateAction } from 'utils/translateStatus';
import BrandApi from 'apis/BrandApi';
import { openNotificationWithIcon } from 'utils/notification';

interface IProps {
  disableField: boolean;
  location: any;
}
export default function BrandEditlPage(props: IProps): JSX.Element {
  const { disableField, location } = props;
  const brandData = location.state.list_user_drop;
  const [form] = useForm();
  const [users, setUsers] = useState<IUser[]>(brandData);
  const history = useHistory();
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const pathSnippets = location.pathname.split('/').filter((i: any) => i);

  const { mutate: getUser } = useMutation(RoleBasedAuth.getUsers, {
    onSuccess: (response) => {
      console.log('success');
      const filteredFields = form.getFieldValue('emails');
      const resultArray = response.data.filter(
        (item) =>
          !filteredFields.some(
            (value: any) => value === item.id + ' - ' + item.email
          )
      );

      setUsers(resultArray);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    setTitle('Chỉnh sửa');
    setBreadcrumb([
      { title: <a href="/brand">Bộ phận phát triển</a> },
      { title: <a href="">{location.state.grp_name}</a> },
    ]);
    setUsers([]);
  }, []);

  const handleEditClick = () => {
    console.log('form', form.getFieldValue('emails'));
    const emailsForm = form.getFieldValue('emails');

    const emails = emailsForm.map((value: any) => ({
      pro_grp_id: location.state.id,
      pro_grp_level: 3,
      user_id: Number(value.split(' - ')[0]),
      email: value.split(' - ')[1],
    }));

    console.log(emails);
    createEmailBrand(emails);
  };

  const { mutate: createEmailBrand } = useMutation(
    BrandApi.createListEmailBrand,
    {
      onSuccess: (data: any) => {
        if (data.status === 200) {
          openNotificationWithIcon('success', 'Cập nhật thành công');
          history.push('/brand');
        }
      },
      onError: () => {
        openNotificationWithIcon('error', 'Cập nhật thất bại');
      },
    }
  );

  return (
    <MainLayout isLoading={false}>
      <Content>
        <Form
          form={form}
          layout="vertical"
          className="items-center"
          autoComplete="off"
        >
          <Form.List
            name={'emails'}
            initialValue={brandData.map(
              (value: any) => value.id + ' - ' + value.email
            )}
          >
            {(fields, { add, remove }, { errors }) => (
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                {fields.map((field, index) => {
                  return (
                    <Col span={12} key={field.key}>
                      <Form.Item
                        label={'Email người quản lý'}
                        required={false}
                        // key={field.key}
                        style={{ marginBottom: '0px' }}
                      >
                        <Row gutter={16}>
                          <Col span={19}>
                            <Form.Item {...field}>
                              <Select
                                placeholder="Nhập email"
                                showSearch
                                options={
                                  users == null || users == undefined
                                    ? []
                                    : users.map((item: any) => ({
                                        label:
                                          item.fullName + ' - ' + item.jobTitle,
                                        value: item.id + ' - ' + item.email,
                                      }))
                                }
                                onFocus={() =>
                                  (users != null || users != undefined) &&
                                  setUsers([])
                                }
                                onSearch={(value) => {
                                  getUser({ email: value });
                                }}
                                onBlur={(value) => {
                                  setUsers([]);
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col style={{ marginTop: '2px' }} span={4}>
                            {index == 0 ? (
                              <Button
                                bgColor={'bg-white'}
                                border={'border-neutral-90'}
                                customClass={'no-show'}
                                onClick={add}
                              >
                                <AddFillIcon />
                              </Button>
                            ) : (
                              <Button
                                bgColor={'bg-white'}
                                border={'border-neutral-90'}
                                customClass={'no-show'}
                                onClick={() => remove(field.name)}
                              >
                                <Remove />
                              </Button>
                            )}
                          </Col>
                        </Row>
                      </Form.Item>
                    </Col>
                  );
                })}
              </Row>
            )}
          </Form.List>
          {/* <Divider dashed />
          <Row>
            <Col className="gutter-row" span={12}>
              <Form.Item name="plantCode" label="Trạng thái">
                <Input.Group compact>
                  <Input
                    style={{ width: 'calc(100% - 105px)', marginRight: '8px' }}
                    // value={brandProps?.name}
                    // disabled={disableField}
                    value={translateAction(location.state.active)}
                    placeholder="Đang hoạt động"
                  />
                </Input.Group>
              </Form.Item>
            </Col>
          </Row> */}
        </Form>
      </Content>
      <div className="mt-5 py-5 border-t-2 border-[#E1E3E6] justify-end flex">
        <Button customClass="mb-5" onClick={handleEditClick}>
          Chỉnh sửa
        </Button>
      </div>
    </MainLayout>
  );
}
